/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkPackageDependencyDtoPage } from '../../models/work-package-dependency-dto-page';
import { WorkPackageDependencyType } from '../../models/work-package-dependency-type';

export interface ListWorkPackageDependencies$Params {
  projectId?: string | null;
  workPackageId?: string | null;
  types?: Array<WorkPackageDependencyType>;
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'workPackageFromId' | '-workPackageFromId' | 'workPackageToId' | '-workPackageToId' | 'type' | '-type' | 'lag' | '-lag' | 'createdAt' | '-createdAt'>;
}

export function listWorkPackageDependencies(http: HttpClient, rootUrl: string, params?: ListWorkPackageDependencies$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackageDependencyDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listWorkPackageDependencies.PATH, 'get');
  if (params) {
    rb.query('projectId', params.projectId, {});
    rb.query('workPackageId', params.workPackageId, {});
    rb.query('types', params.types, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkPackageDependencyDtoPage>;
    })
  );
}

listWorkPackageDependencies.PATH = '/v0/workPackageDependencies';
